import React, { useMemo } from "react";
import { Dropdown } from "react-bootstrap";

import cx from 'classnames';
import styles from "./sortBy.module.scss";

const SORT_BY_VALUES = [{
  label: 'name',
  value: 'Name',
}, {
  label: 'created_date',
  value: 'Created date',
}, {
  label: 'modified_date',
  value: 'Last updated date',
}];

interface SortByActionProps {
  value: { sortBy: string, orderBy: string },
  // eslint-disable-next-line no-unused-vars
  onChange: (value: { sortBy: string, orderBy: string }) => void
}

const SortByAction = ({ value, onChange }: SortByActionProps) => {
  const sortOrder = value.orderBy;
  const sortBy = value.sortBy;

  const sortByLabel = useMemo(() => {
    return SORT_BY_VALUES.find(item => item.label === sortBy)?.value;
  }, [sortBy]);

  const toggleSortOrder = () => {
    onChange({
      ...value,
      orderBy: sortOrder === 'asc' ? 'desc' : 'asc'
    });
  }

  const handleSortByChange = (change: string) => {
    let sortOrderValue = sortOrder;

    if (sortBy === change) {
      sortOrderValue = sortOrder === 'asc' ? 'desc' : 'asc';
    }

    onChange({
      sortBy: change,
      orderBy: sortOrderValue
    });
  }

  return (
    <div className={styles.container}>
      <div className={styles.details}>
        <div className={styles.title}>Sort by</div>
        <div className={styles.field}>
          {sortByLabel}
          <div className={cx(styles.indicator, styles[sortOrder])} onClick={toggleSortOrder}>
            <i className={cx(styles.arrow, styles.up, "paperflite-dropdown")}></i>
            <i className={cx(styles.arrow, styles.down, "paperflite-dropdown")}></i>
          </div>
        </div>
      </div>
      <Dropdown>
        <Dropdown.Toggle className={styles.button} as={'button'}>
          <i className={cx(styles.icon, "paperflite-menu")}></i>
        </Dropdown.Toggle>
        <Dropdown.Menu className={styles.dropdown} popperConfig={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 6],
              },
            },
          ],
        }}>
          {SORT_BY_VALUES.map((item, index) => {
            const active = item.label === sortBy;
            return <Dropdown.Item key={index}
              className={cx(styles.dropdownItem, { [styles.active]: active })}
              onClick={() => handleSortByChange(item.label)}>
              {item.value}
            </Dropdown.Item>
          })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export { SortByAction };